import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractRefundInvoiceEmailTemplate.Save.IRequest;
type Response = Api.Core.ContractRefundInvoiceEmailTemplate.Save.IResponse;
type Headers = Api.Core.ContractRefundInvoiceEmailTemplate.Save.IHeaders;
const url = '/api/Management/ContractRefundInvoiceEmailTemplate';
export default async function contractRefundInvoiceEmailTemplateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
